import { lazyLoad } from 'utils/loadable';

export const ClientPage = lazyLoad(
  () => import('./index'),
  module => module.ClientPage,
);
